import {
    StatsigExperimentCohort,
    StatsigExperimentKey
} from "src/feature-gates/types";

import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";
import { MeResponse, ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import { AvailableProductsResponse } from "@/libraries/bxp-web-stargate-client/src";
import { IntercomProvider } from "@/libraries/intercom/src";
import RedirectSpinner from "@/templates/jira-product-tour-overview/src/sections/atlas-63936-redirect-spinner/redirect-spinner";
import {
    LoggedInJiraProductTourOverview,
    LoggedOutOrNoJiraProductTourOverview
} from "@/templates/jira-product-tour-overview/src/templates";

export type JiraSoftwarePageProps = {
    availableProducts: AvailableProductsResponse | null;
    userProfile: MeResponse | null;
};

export const JiraSoftwarePage = (props: JiraSoftwarePageProps) => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-jsw"
    );

    let template = (
        <LoggedInJiraProductTourOverview
            availableProducts={props.availableProducts}
            userProfile={props.userProfile}
        />
    );

    // Jira Product Tour Overview for logged out users & users that don't have jira
    const jiraInstanceFound = props.availableProducts?.sites
        .map((item) => item.products.includes("jira-software.ondemand"))
        .includes(true);

    if (!jiraInstanceFound) {
        template = <LoggedOutOrNoJiraProductTourOverview />;
    } else {
        const redirectUserToProductExperimentValue: string =
            FeatureGates.getExperimentValue(
                StatsigExperimentKey.JFIND_REDIRECT_TO_PRODUCT,
                "cohort",
                StatsigExperimentCohort.JFIND_REDIRECT_TO_PRODUCT_CONTROL,
                { fireExperimentExposure: true }
            );

        if (
            redirectUserToProductExperimentValue ===
            StatsigExperimentCohort.JFIND_REDIRECT_TO_PRODUCT_VARIANT
        ) {
            template = (
                <RedirectSpinner availableProducts={props.availableProducts} />
            );
        }
    }

    return (
        <UFOSegment name="jira-product-tour-overview">
            <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
                <CrossFlowTouchpointProvider
                    productKeys={[ProductKeys.JIRA_SOFTWARE]}
                    screenName="wacJswProductTourPage"
                >
                    {template}
                </CrossFlowTouchpointProvider>
            </IntercomProvider>
        </UFOSegment>
    );
};
